import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const swedishPhoneNumber = (t: TFunction) =>
    Yup.string()
        .nullable()
        .typeError(t<string>('validation:phonenumber.required'))
        .required(t<string>('validation:phonenumber.required'))
        .test(
            'test-swedishphoneNumber', // this is used internally by yup
            t<string>('validation:phonenumber.invalid'), //validation message
            (value) => {
                const { isValid } = parseSwedishMobilePhoneNumber(value);

                return isValid;
            }
        );

export function isValidMobileNumber(number: string) {
    return parseSwedishMobilePhoneNumber(number).isValid;
}

const SE_MOBILE_RE = /^(((\+|00|0)?46)|0)?(?<network>7(0|2|3|6|9))(?<number>\d{7})$/;
const NUMBERS_AND_PLUSS = /[^+\d]/g;

export function parseSwedishMobilePhoneNumber(candidate: string): { isValid: false } | { network: string; number: string; isValid: true } {
    const cleaned = candidate.replace(NUMBERS_AND_PLUSS, '');
    const m = SE_MOBILE_RE.exec(cleaned);
    if (m) {
        const network = m.groups?.['network'];
        const number = m.groups?.['number'];
        if (network && number) {
            return { network, number, isValid: true };
        }
    }

    return { isValid: false };
}
